var _ellipse, _ellipse2, _path, _ellipse3, _ellipse4, _path2, _ellipse5, _ellipse6, _path3, _ellipse7, _ellipse8, _path4, _ellipse9, _ellipse10, _path5, _ellipse11, _ellipse12, _path6, _ellipse13, _ellipse14, _path7, _ellipse15, _ellipse16, _path8, _ellipse17, _ellipse18, _path9, _ellipse19, _ellipse20, _path10, _ellipse21, _ellipse22, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcLoanServiceBody(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 238,
    height: 238,
    viewBox: "0 0 238 238",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.3085,
    cy: 109.72,
    rx: 35.5442,
    ry: 27.9276,
    fill: "#8D8D8D"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.3085,
    cy: 104.641,
    rx: 35.5442,
    ry: 27.9276,
    fill: "#C1C1C1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.6251 115.325L70.9886 88.3993H77.435L82.1954 107.342H82.4433L87.2533 88.3993H93.65L98.5096 107.242H98.7575L103.468 88.3993H109.915L102.278 115.325H95.6831L90.6252 97.0771H90.2781L85.2202 115.325H78.6251Z",
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.331,
    cy: 158.76,
    rx: 35.5442,
    ry: 27.9276,
    fill: "#B2B2B2"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.331,
    cy: 153.682,
    rx: 35.5442,
    ry: 27.9276,
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6477 164.366L43.0112 137.44H49.4576L54.218 156.383H54.4659L59.2759 137.44H65.6726L70.5322 156.283H70.7801L75.4909 137.44H81.9373L74.3008 164.366H67.7057L62.6478 146.118H62.3007L57.2428 164.366H50.6477Z",
    fill: "white"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.2393,
    cy: 143.857,
    rx: 35.5442,
    ry: 27.9276,
    fill: "#B2B2B2"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.2393,
    cy: 138.779,
    rx: 35.5442,
    ry: 27.9276,
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5559 149.463L42.9195 122.537H49.3658L54.1262 141.479H54.3741L59.1841 122.537H65.5809L70.4404 141.38H70.6884L75.3992 122.537H81.8455L74.2091 149.463H67.614L62.5561 131.215H62.2089L57.151 149.463H50.5559Z",
    fill: "white"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.2393,
    cy: 128.534,
    rx: 35.5442,
    ry: 27.9276,
    fill: "#B2B2B2"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.2393,
    cy: 123.456,
    rx: 35.5442,
    ry: 27.9276,
    fill: "#D9D9D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5559 134.14L42.9195 107.214H49.3658L54.1262 126.156H54.3741L59.1841 107.214H65.5809L70.4404 126.057H70.6884L75.3992 107.214H81.8455L74.2091 134.14H67.614L62.5561 115.892H62.2089L57.151 134.14H50.5559Z",
    fill: "white"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.761,
    cy: 176.14,
    rx: 35.5442,
    ry: 27.9276,
    fill: "#B2B2B2"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.761,
    cy: 171.061,
    rx: 35.5442,
    ry: 27.9276,
    fill: "#D9D9D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M164.077 181.745L156.441 154.819H162.887L167.648 173.762H167.896L172.706 154.819H179.102L183.962 173.662H184.21L188.921 154.819H195.367L187.731 181.745H181.135L176.077 163.497H175.73L170.672 181.745H164.077Z",
    fill: "white"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.669,
    cy: 161.236,
    rx: 35.5442,
    ry: 27.9276,
    fill: "#B2B2B2"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.669,
    cy: 156.158,
    rx: 35.5442,
    ry: 27.9276,
    fill: "#D9D9D9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M163.986 166.843L156.349 139.917H162.795L167.556 158.859H167.804L172.614 139.917H179.011L183.87 158.76H184.118L188.829 139.917H195.275L187.639 166.843H181.044L175.986 148.595H175.639L170.581 166.843H163.986Z",
    fill: "white"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.669,
    cy: 145.913,
    rx: 35.5442,
    ry: 27.9276,
    fill: "#B2B2B2"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.669,
    cy: 140.835,
    rx: 35.5442,
    ry: 27.9276,
    fill: "#D9D9D9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M163.986 151.52L156.349 124.594H162.795L167.556 143.536H167.804L172.614 124.594H179.011L183.87 143.437H184.118L188.829 124.594H195.275L187.639 151.52H181.044L175.986 133.271H175.639L170.581 151.52H163.986Z",
    fill: "white"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.669,
    cy: 130.832,
    rx: 35.5442,
    ry: 27.9276,
    fill: "#B2B2B2"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.669,
    cy: 125.754,
    rx: 35.5442,
    ry: 27.9276,
    fill: "#D9D9D9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M163.986 136.438L156.349 109.512H162.795L167.556 128.454H167.804L172.614 109.512H179.011L183.87 128.355H184.118L188.829 109.512H195.275L187.639 136.438H181.044L175.986 118.189H175.639L170.581 136.438H163.986Z",
    fill: "white"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.669,
    cy: 116.829,
    rx: 35.5442,
    ry: 27.9276,
    fill: "#B2B2B2"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.669,
    cy: 111.751,
    rx: 35.5442,
    ry: 27.9276,
    fill: "#D9D9D9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M163.986 122.435L156.349 95.5086H162.795L167.556 114.451H167.804L172.614 95.5086H179.011L183.87 114.352H184.118L188.829 95.5086H195.275L187.639 122.435H181.044L175.986 104.186H175.639L170.581 122.435H163.986Z",
    fill: "white"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.669,
    cy: 103.548,
    rx: 35.5442,
    ry: 27.9276,
    fill: "#B2B2B2"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.669,
    cy: 98.4696,
    rx: 35.5442,
    ry: 27.9276,
    fill: "#D9D9D9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M163.986 109.153L156.349 82.2274H162.795L167.556 101.17H167.804L172.614 82.2274H179.011L183.87 101.071H184.118L188.829 82.2274H195.275L187.639 109.153H181.044L175.986 90.9052H175.639L170.581 109.153H163.986Z",
    fill: "white"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.669,
    cy: 92.3397,
    rx: 35.5442,
    ry: 27.9276,
    fill: "#B2B2B2"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.669,
    cy: 87.2616,
    rx: 35.5442,
    ry: 27.9276,
    fill: "#D9D9D9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M163.986 97.9453L156.349 71.0194H162.795L167.556 89.9618H167.804L172.614 71.0194H179.011L183.87 89.8626H184.118L188.829 71.0194H195.275L187.639 97.9453H181.044L175.986 79.6972H175.639L170.581 97.9453H163.986Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLoanServiceBody);
export default __webpack_public_path__ + "static/media/IcLoanServiceBody.affae4b40711769594e0f5d539726166.svg";
export { ForwardRef as ReactComponent };